import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const userManagement = 'UserManagement'

export const getMyUserManagement = () => {
  return axios.get(`/${userManagement}`)
}
